import { render, staticRenderFns } from "./SaleReports.vue?vue&type=template&id=2ca579b6"
import script from "./SaleReports.vue?vue&type=script&lang=js"
export * from "./SaleReports.vue?vue&type=script&lang=js"
import style0 from "./SaleReports.vue?vue&type=style&index=0&id=2ca579b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports